import { useParams } from 'react-router-dom';

import { FullScreenLoading, industryTransform } from '@backrs_ui/common-ui';

import { usePageTitle } from '@backrs_ui/grow-ui/src/hooks/usePageTitle';
import { useGetIndustryByIdQuery } from '@backrs_ui/grow-ui/src/redux/industry/industry.api';

import { useAgentContext } from './IndustriesPageContainer.agentContext';
import { IndustryPage } from './IndustryPage';

export const IndustriesPageContainer = () => {
  const { industryId } = useParams();

  const {
    data: industry,
    isLoading,
    isError,
  } = useGetIndustryByIdQuery(industryId || '', {
    skip: !industryId,
  });

  usePageTitle(industry?.name);
  useAgentContext(industry);

  if (!industryId || isError || !industry || isLoading) {
    return <FullScreenLoading />;
  }

  const industryNugget = industryTransform(industry);

  return <IndustryPage nugget={industryNugget} />;
};
